import EventConstants from '../../constants/EventConstants'
import { AxiosUtil } from '../../utils/axios-util'
import { errorResponseNotification } from '../notification-service'

export const getPlannedProducts = ({ eventId, productStatus, request }) => {
  const url =
    EventConstants.POTENTIAL_ITEMS +
    'aggregations_search_with_bps?event_id=' +
    eventId +
    '&product_status=' +
    productStatus +
    '&top_level_only=true&include_forecasts=true&fetch_all=true'
  return AxiosUtil.post(url, request).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}

export const associateProducts = ({ request, isCFProduct }) => {
  if (isCFProduct) {
    return AxiosUtil.post(
      `${EventConstants.INTERNAL_ITEM_BP}/copy`,
      request,
    ).catch(err => {
      throw err
    })
  }
  return AxiosUtil.post(
    `${EventConstants.INTERNAL_ITEM_BP}/create?`,
    request,
  ).catch(err => {
    throw err
  })
}
